import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';
import { isEmpty, map, find } from 'lodash';

import * as atlasOps from '../../../api/Atlas/atlas-operations';
import Atlas from '../../../api/Atlas/Atlas';

import getAtlasPropsToPass from '../../../modules/get-atlas-props-to-pass';

import { ATLAS_ELEMENTS } from '../../atoms/AtlasAtoms/atlas-elements';
import Loading from '../../components/Loading';
import NotFound from '../NotFound';
import UserSharedModal from '../../components/UserSharedModal';

const { isTierra2 } = Meteor.settings.public;

const PublicAtlas = ({ atlas, deployEnv, loading, openModalUserPrivate, sharedUser }) => {
  if (isEmpty(atlas) || isTierra2) return <NotFound />;
  if (loading) return <Loading />;
  const [openModal, setOpenModal] = React.useState(
    openModalUserPrivate || atlasOps.getIsNameShared(atlas) === true
  );
  const [nameToEnter, setNameToEnter] = React.useState('');
  const [userToSecondEnter, setUserToSecondEnter] = React.useState({
    id: '',
    name: '',
    password: ''
  });

  const createUserLocalId = () => {
    // Obtener el objeto desde localStorage
    let userIpsilum = JSON.parse(localStorage.getItem('userIpsilum'));

    // Generar un nuevo ID si el objeto no existe o no tiene un ID
    if (!userIpsilum || !userIpsilum.id) {
      const newId = Array.from({ length: 18 }, () => Math.random().toString(36)[2]).join('');
      userIpsilum = {
        id: newId,
        name: nameToEnter || 'userIpsilum' // Usa el nombre proporcionado o el valor predeterminado
      };
      localStorage.setItem('userIpsilum', JSON.stringify(userIpsilum));
    } else if (userIpsilum.name !== nameToEnter) {
      // Si el objeto existe pero el nombre es diferente, actualizarlo
      userIpsilum.name = nameToEnter;
      localStorage.setItem('userIpsilum', JSON.stringify(userIpsilum));
    }

    return userIpsilum;
  };

  const userProps = {
    userId: userToSecondEnter.id || '',
    roles: 'premium',
    name: nameToEnter || createUserLocalId().name || userToSecondEnter.name || '',
    emailAddress: '',
    userLocalId: createUserLocalId()
  };

  return (
    <>
      <UserSharedModal
        atlas={{ ...atlas }}
        nameToEnter={nameToEnter}
        setNameToEnter={setNameToEnter}
        openModal={openModal}
        setOpenModal={setOpenModal}
        userToSecondEnter={userToSecondEnter}
        setUserToSecondEnter={setUserToSecondEnter}
        isAtlas
        sharedUser={sharedUser}
      />
      <Row className="h-100">
        <Col xs={12} className="px-0 h-100">
          <div style={{ height: '100vh' }}>
            {map(atlasOps.getAtlasStructure(atlas), (element, index) => {
              const { component } = find(ATLAS_ELEMENTS.properties, ['value', element]);
              return React.cloneElement(component, {
                key: `${element}-${index}-view`,
                atlas,
                userProps,
                deployEnv,
                isPublic: true,
                ...getAtlasPropsToPass(atlas)[index]
              });
            })}
          </div>
        </Col>
      </Row>
    </>
  );
};

PublicAtlas.defaultProps = {
  atlas: {},
  openModalUserPrivate: false,
  sharedUser: false
};

PublicAtlas.propTypes = {
  atlas: PropTypes.object,
  deployEnv: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  openModalUserPrivate: PropTypes.bool,
  sharedUser: PropTypes.bool
};

export default withTracker(({ match, privateShared, sharedUser }) => {
  let subscriptionType = 'atlas.public';
  if (privateShared) {
    subscriptionType = 'atlas.private';
  } else if (sharedUser) {
    subscriptionType = 'atlas.publicUser';
  }
  const atlasPublicId = match.params.public_atlas_id;
  const atlasSub = Meteor.isClient && Meteor.subscribe(subscriptionType, atlasPublicId);

  return {
    loading: !Meteor.isClient || !atlasSub.ready(),
    atlas: Atlas.findOne({ publicId: atlasPublicId })
  };
})(PublicAtlas);
